import React from 'react';
import PropTypes from 'prop-types';

export default function Comcast({ twilioNumber }) {
  return (
    <div>
      <ul>
        <li>Step 0: Drain any unread messages in your voicemail</li>
        <li>
          Step 1: Dial *92
          &gt; you will hear a second dial tone
          &gt; dial { twilioNumber }
          &gt; wait for confirmation tone and hang up
        </li>
        <li>
          Step 2: Dial *90
          &gt; you will hear a second dial tone
          &gt; dial { twilioNumber }
          &gt; wait for confirmation tone and hang up
        </li>
      </ul>
    </div>
  );
}

Comcast.defaultProps = {
  twilioNumber: '',
};

Comcast.propTypes = {
  twilioNumber: PropTypes.string,
};
